{
  "actions": "Azioni",
  "actionsAvailable": "Azioni disponibili.",
  "clearSelection": "Annulla selezione",
  "selected": "{count, plural, =0 {Nessuno selezionato} other {# selezionato/i}}",
  "selectedAll": "Tutti selezionati"
}
